import { render, staticRenderFns } from "./Noc.vue?vue&type=template&id=285aa726&scoped=true&"
import script from "./Noc.vue?vue&type=script&lang=js&"
export * from "./Noc.vue?vue&type=script&lang=js&"
import style0 from "./Noc.vue?vue&type=style&index=0&id=285aa726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285aa726",
  null
  
)

export default component.exports